import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.scss';
import { ModalProvider } from './context/modal-context'
import App from './components/app/app';

const rootElId = 'mlb-alpine-form';

if (!document.getElementById(rootElId)) {
    const el = document.createElement('div');
    el.setAttribute('id', rootElId);
    document.body.appendChild(el);
}

const rootEl = document.getElementById(rootElId);

ReactDOM.render(
  <React.StrictMode>
      <ModalProvider>
          <App />
      </ModalProvider>
  </React.StrictMode>, rootEl
);